import { useState } from "react";
import { Plus, ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";
import PurchaseModal from "@/components/inventory/PurchaseModal";
import { INVENTORY } from "@/constants/testIds";
import { formatQty } from "@/lib/inventoryConstants";

function formatDate(iso) {
  const d = new Date(iso);
  return d.toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" });
}

export default function PurchasesTab({ purchases, products, loading, onCreate }) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-end">
        <Button className="bg-brand hover:bg-brand-hover text-white" onClick={() => setModalOpen(true)} data-testid={INVENTORY.purchasesAddButton}>
          <Plus className="w-4 h-4" /> Registrar compra
        </Button>
      </div>

      {loading ? (
        <p className="text-center text-muted-foreground py-12">Cargando compras...</p>
      ) : purchases.length === 0 ? (
        <div className="bg-white border border-border rounded-xl p-12 text-center" data-testid={INVENTORY.purchasesEmptyState}>
          <ShoppingCart className="w-10 h-10 text-muted-foreground mx-auto mb-3" />
          <p className="text-muted-foreground">Todavía no registraste ingresos de mercaderia.</p>
        </div>
      ) : (
        <div className="space-y-2" data-testid={INVENTORY.purchasesList}>
          {purchases.map((p) => (
            <div key={p.id} className="bg-white border border-border rounded-xl p-4 flex items-center justify-between flex-wrap gap-2" data-testid={`${INVENTORY.purchaseItemPrefix}${p.id}`}>
              <div>
                <p className="text-sm font-medium text-foreground">{p.product_name}</p>
                <p className="text-xs text-muted-foreground">
                  {formatQty(p.quantity)} unid. &middot; ${p.unit_cost.toFixed(2)}/unid. &middot; total ${p.total_cost.toFixed(2)}
                  {p.supplier ? ` \u00b7 ${p.supplier}` : ""}
                </p>
              </div>
              <span className="text-xs text-muted-foreground shrink-0">{formatDate(p.purchase_date)}</span>
            </div>
          ))}
        </div>
      )}

      <PurchaseModal open={modalOpen} onOpenChange={setModalOpen} products={products} onSubmit={onCreate} />
    </div>
  );
}
